import { Controller } from "@hotwired/stimulus"

// Flechas del carrusel de la vitrina (.store-carousel__viewport) y del Pasillo retail (.store-aisle__rail): el gesto
// lo hace CSS scroll-snap; esto desplaza una vista al click, apaga la flecha del extremo y conserva el scroll de la
// pista entre snapshots de Turbo. Ver discount.md y storefront_catalog.md → Restore de la tienda
export default class extends Controller {
  static targets = ["track", "prev", "next"]
  static values = { columns: Number, scrollLeft: Number }

  // Con scroll guardado (volver a la tienda) lo repone antes de pintar, dibujando el riel diferido (sin dibujar mide
  // 0 y no se desplaza; store-lazy lo vuelve a diferir en la próxima salida). No en una vista previa (visita normal
  // a una página cacheada): la página fresca que la reemplaza trae la pista en 0 y el riel saltaría. Reevalúa las
  // flechas también cuando el riel diferido (content-visibility) se dibuja
  connect() {
    this.update = this.update.bind(this)
    if (this.scrollLeftValue > 0 && !document.documentElement.hasAttribute("data-turbo-preview")) {
      this.element.style.contentVisibility = "visible"
      this.trackTarget.scrollLeft = this.scrollLeftValue
    }
    this.trackTarget.addEventListener("scroll", this.update, { passive: true })
    this.element.addEventListener("contentvisibilityautostatechange", this.update)
    window.addEventListener("resize", this.update)
    this.update()
  }

  // turbo:before-cache: el snapshot no conserva el scroll de la pista; queda en el valor (atributo) que sí viaja
  keepScroll() {
    this.scrollLeftValue = this.trackTarget.scrollLeft
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.update)
    this.element.removeEventListener("contentvisibilityautostatechange", this.update)
    window.removeEventListener("resize", this.update)
  }

  prev() {
    this.scrollByView(-1)
  }

  next() {
    this.scrollByView(1)
  }

  // Una vista = las cards que caben enteras (2 en el diseño) o el bloque (`columns`); el snap termina de alinear
  scrollByView(direction) {
    const card = this.trackTarget.firstElementChild
    if (!card) return

    const gap = parseFloat(getComputedStyle(this.trackTarget).columnGap) || 0
    const step = card.getBoundingClientRect().width + gap
    const perView = this.columnsValue || Math.max(1, Math.floor((this.trackTarget.clientWidth + gap) / step))
    this.trackTarget.scrollBy({ left: step * perView * direction, behavior: "smooth" })
  }

  update() {
    const { scrollLeft, clientWidth, scrollWidth } = this.trackTarget
    this.prevTarget.disabled = scrollLeft <= 1
    this.nextTarget.disabled = scrollLeft + clientWidth >= scrollWidth - 1
  }
}
